import React from 'react'
import PropTypes from 'prop-types'
import { Card } from 'transfix-ui/components/Card'
import { Confirmed } from './Stops/Confirmed'
import { Unconfirmed } from './Stops/Unconfirmed'

/**
 * @deprecated Please delete this file when mpNewSchedulerPage got turned on in prod
 */
export const OtherStopsCard = React.memo(({ apptType, otherStops, stopType }) => (
  <Card>
    <div className='pv5'>
      <h3>
        Are you able to confirm {otherStops.length === 1 ? 'this' : 'these'} appointment
        {otherStops.length === 1 ? '' : 's'} while you are here?
      </h3>
    </div>
    {otherStops.map(stop => {
      const { appointmentStatus, confirmed, stopId } = stop
      if (confirmed || appointmentStatus === 'confirmed') {
        return <Confirmed stop={stop} apptType={apptType} stopType={stopType} key={stopId} />
      }
      return <Unconfirmed stop={stop} apptType={apptType} stopType={stopType} key={stopId} />
    })}
  </Card>
))

OtherStopsCard.propTypes = {
  otherStops: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  apptType: PropTypes.string.isRequired,
  stopType: PropTypes.string.isRequired,
}
